import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Hero from '../sections/Hero';
import TrustBar from '../sections/TrustBar';
import About from '../sections/About';
import PracticeAreas from '../sections/PracticeAreas';
import ExpatSection from '../sections/ExpatSection';
import WhyChooseUs from '../sections/WhyChooseUs';
import { BlogTeaser } from '../sections/Blog';
import { GOOGLE_MAPS_URL } from '../constants';
import usePageMeta from '../hooks/usePageMeta';
import useLangPrefix from '../hooks/useLangPrefix';

function Home() {
  const { t } = useTranslation();
  const langPrefix = useLangPrefix();

  usePageMeta({ path: langPrefix || '/' });

  return (
    <>
      <Hero />
      <TrustBar />
      <About />
      <PracticeAreas variant="home" />
      <ExpatSection />
      <WhyChooseUs />
      <BlogTeaser />
      <section className="py-5 py-lg-6 bg-navy text-white text-center">
        <div className="container">
          <h2 className="h3 fw-semibold mb-2">{t('home.ctaHeading')}</h2>
          <p className="text-white-50 mb-4">{t('home.ctaSubheading')}</p>
          <Link to={`${langPrefix}/contact`} className="btn btn-light px-4 text-navy fw-semibold">
            {t('hero.cta')}
          </Link>
          <p className="small text-white-50 mt-4 mb-0">
            <a className="text-white-50" href={GOOGLE_MAPS_URL} target="_blank" rel="noopener noreferrer">
              {t('home.ctaMaps')}
            </a>
          </p>
        </div>
      </section>
    </>
  );
}

export default Home;
